import { render } from "../templates/modelsCompleted.html?vue&type=template&id=64356e12"
import script from "./modelsCompleted.vue?vue&type=script&lang=js"
export * from "./modelsCompleted.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__